// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1KT9o","author":"Table_author__j_FEI","authorImage":"Table_authorImage__3nROe","unreadRow":"Table_unreadRow__1Hjmc"};